/*
**************************** 
홈페이지 유저정보 비번변경
*****************************
*/

import axios from "axios";
import React, { useEffect, useState } from "react";

export default function ProfileNewPassword(props) {
    const [changeData, setChangeData] = useState({});

    useEffect(() => {

        let copyData = { ...changeData };
        copyData = props.changeData;
        setChangeData(copyData);

        return () => {

        };
    }, [props.changeData])

    const submit = async function (e) {
        e.preventDefault();
        const user_id = changeData.id;
        const login_id = changeData.login_id;

        const password = e.target.password.value;
        const passwordConfirm = e.target.password_confirm.value;

        if (password !== passwordConfirm) {
            alert("비밀번호가 일치하지 않습니다");
            return;
        }

        const reqSql = "/api/users/pass";
        const params = { user_id, login_id, password };
        await axios.post(reqSql, params, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {

            if (res.status === 201) {
                alert("비밀번호가 변경되었습니다. 메인으로 이동합니다.");
                window.location.href = "/";
            } else {
                if (res.status === 204) {
                    alert("비밀번호 변경 실패");
                } else {
                    alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                }
            }
        }).catch(function (err) {
            console.log(err);
            alert("데이터 가져오는 도중 오류가 발생하였습니다.");
        });
    }
    return (
        <div>
            <div className="modal fade" id="profileNewPassword" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title fw-bold" id="exampleModalLabel">비밀번호 변경</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="sign-in">
                                <form onSubmit={submit}>
                                    <div className="form-group text-start">
                                        <label className="form-label mt-4 fw-bolder" >아이디 : {changeData.login_id}</label>
                                        <input type="password" className="form-control" placeholder="비밀번호" name="password" minLength="8" required></input>
                                        <input type="password" className="form-control mt-2" placeholder="비밀번호 확인" name="password_confirm" minLength="8" required></input>
                                    </div>
                                    <div className="form-group mt-4 row p-2">
                                        <input type="submit" className="btn btn-lg btn-primary" value="제출"></input>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}